import { parseDateApiFormat, parseDateInputFormat } from '../../utils/parseDateFormats';

export const getEquimentUsageReport = (state) => {
  return state.equipmentUsageReport;
};

export const getStartDate = (state) => {
  const { startDate } = getEquimentUsageReport(state);
  return startDate;
};

export const getStartDateApiFormat = (state) => {
  const startDate = getStartDate(state);
  return (!startDate) ? startDate : parseDateApiFormat(startDate);
};

export const getStartDateInputFormat = (state) => {
  const startDate = getStartDate(state);
  return (!startDate) ? startDate : parseDateInputFormat(startDate);
};

export const getEndDate = (state) => {
  const { endDate } = getEquimentUsageReport(state);
  return endDate;
};

export const getEndDateApiFormat = (state) => {
  const endDate = getEndDate(state);
  return (!endDate) ? endDate : parseDateApiFormat(endDate);
};

export const getEndDateInputFormat = (state) => {
  const endDate = getEndDate(state);
  return (!endDate) ? endDate : parseDateInputFormat(endDate);
};

export const getEquipment = (state) => {
  const { equipment } = getEquimentUsageReport(state);
  return equipment;
};
